import { useState } from 'react';

import { Box, Divider } from '@chakra-ui/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@mesh.ai/rabbit';

import { TextLabel } from 'uiToolkitV1/Typography';

const RecurringReviewTrigger = () => {
  const [selectedFrequency, setSelectedFrequency] = useState<string>('1 months');
  return (
    <Card
      style={{
        background: '#FDFDFD',
      }}
    >
      <CardHeader>
        <CardTitle>Frequency</CardTitle>
        <Divider mt="8px" color="#EBEFF3" opacity={1} />
      </CardHeader>
      <CardContent>
        <Box
          display="flex"
          width="320px"
          padding="4px 12px 8px 0px"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          gap="8px"
        >
          <TextLabel>Select frequency</TextLabel>
          <Select value={selectedFrequency} onValueChange={(value) => setSelectedFrequency(value)}>
            <SelectTrigger style={{ marginRight: '8px' }} className="w-[180px]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectItem value="1 months">1 months</SelectItem>
                <SelectItem value="2 months">2 months</SelectItem>
                <SelectItem value="3 months">3 months</SelectItem>
                <SelectItem value="6 months">6 months</SelectItem>
                <SelectItem value="12 months">12 months</SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>
        </Box>
      </CardContent>
    </Card>
  );
};

export { RecurringReviewTrigger };
